// @TODO: confetti still not working
/*
 * Ryan O'Dowd
 * 2025-06-01
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import 'react-native-reanimated';
import React from 'react';
import {
  TestProps,
} from './Test';
import {
  Text,
} from 'react-native';
import {
  WithSkiaWeb,
} from '@shopify/react-native-skia/lib/module/web';
import {
  version,
} from 'canvaskit-wasm/package.json';

const TestWrapper = (props: TestProps) => {
  return (
    <WithSkiaWeb
      opts={{locateFile: (file) => `https://cdn.jsdelivr.net/npm/canvaskit-wasm@${version}/bin/full/${file}`}}
      getComponent={() => import('./Test')}
      fallback={<Text>Loading TODO...</Text>}// @TODO: loading indicator
      componentProps={props}
    />
  );
};

export default TestWrapper;
